import React, { useEffect, useState } from "react";
import "./Imperiality_view_offcanvas.css";
import { Offcanvas, Form } from "react-bootstrap";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Certification_Modal from "../../../../../../../common/common_modal/certification_modal/Certification_Modal";
import { GetSingle } from "../../../../../../../features/admin/quality_management/general_requirement/imperiality/Slice";
import { useDispatch } from "react-redux";
//
function Imperiality_view_offcanvas({ show, handleClose, id }) {
  const [showModal, setShowModal] = useState(false);

  const [details, setDetails] = useState(null);
  const [modalImage, setModalImage] = useState(null);
  const dispatch = useDispatch();
  const GetData = async (id) => {
    const res = await dispatch(GetSingle(id));

    if (res?.payload?.success) {
      setDetails(res.payload.data);
    }
  };

  useEffect(() => {
    if (show === true && id) {
      GetData(id);
    }
  }, [show]);
  const fileUrl = details?.imperiality
    ? `${process.env.REACT_APP_IMG_URL}${details?.imperiality}`
    : null;

  const getFileType = (url) => {
    if (!url) return "unknown";

    const ext = url
      .split(".")
      .pop()
      .toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (ext === "pdf") return "pdf";
    if (["doc", "docx"].includes(ext)) return "word";
    return "other";
  };

  const fileType = getFileType(fileUrl);
  return (
    <>
      <Offcanvas
        className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
        show={show}
        placement="end"
        onHide={handleClose}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <div className="back_div" onClick={handleClose}>
              <Common_Back_Btn />
            </div>
            Imperiality
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="white_container customer_section  ">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Employee ID</Form.Label>
                  <Form.Control value={details?.unique_id} disabled />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Employee Name</Form.Label>
                  <Form.Control value={details?.name} disabled />
                </Form.Group>
              </div>

              <div className="col-md-12">
                <Form.Group className="form_group">
                  <Form.Label>Designation</Form.Label>
                  <Form.Control value={details?.Role?.name} disabled />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group file_field">
                  <Form.Label>Attached File</Form.Label>
                  <div className="image_holder">
                    <div className="file_preview">
                      {!fileUrl ? (
                        <div className="no_file">
                          <p>🚫 No file uploaded</p>
                          {/* <img
                            className="img_preview"
                            src="/assets/images/other/dummy-image.png"
                            alt="Default"
                          /> */}
                        </div>
                      ) : fileType === "image" ? (
                        <img
                          className="img_preview"
                          src={fileUrl}
                          alt="Preview"
                        />
                      ) : fileType === "pdf" ? (
                        <iframe
                          src={fileUrl}
                          width="100%"
                          height="400px"
                          title="PDF Preview"
                        />
                      ) : fileType === "word" ? (
                        <div>
                          <p>📄 Word file preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open Document
                          </a>
                        </div>
                      ) : (
                        <div>
                          <p>📁 File preview not available</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Download File
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* <div className="span_text_holder">
                    <div>
                      <span>Imperiality PDF.2Kb</span>
                    </div>

                    <div>
                      <span
                        className="green_text"
                        onClick={() => {
                          setShowModal(true);
                          setModalImage(
                            details?.imperiality
                              ? `${process.env.REACT_APP_IMG_URL}${details?.imperiality}`
                              : null,
                          );
                          handleClose();
                        }}
                      >
                        <FontAwesomeIcon icon={faEye} className="me-2" /> View
                      </span>
                    </div>
                  </div> */}
                </Form.Group>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Certification_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        modalHeadingText={"View Imperiality"}
        imgSrc={modalImage}
        btnText={"Download"}
        title="Imperiality"
      />
    </>
  );
}

export default Imperiality_view_offcanvas;
